export default "__VITE_ASSET__9f1150ef__"